/* eslint-disable react/jsx-no-target-blank */
import images from 'assets/images/images'
import { useTranslation } from 'react-i18next'

const Copyright = ({footerPhoneLogoPath,socialMedia}) => {
  const { t } = useTranslation()
 
  return (
    <div className='copyright row'>
        <div className='copyright-left col-md-4'>
           {t('copyRightText')}
        </div>
        {
          footerPhoneLogoPath && <div className="col-md-4 d-flex justify-content-center">
            <img className='copyright-icon' src={footerPhoneLogoPath} alt="Tavuk Dünyası Tel" />
          </div>
        }
        <div className='copyright-right col-md-4'>
            {
              socialMedia && (
                <div className='socialMediaIcon'>
                  { socialMedia.facebook &&
                    <a target="_blank" href={socialMedia.facebook}>
                      <img src={images.facebookFooter} alt="Facebook Logo" />
                    </a>
                  }
                  { socialMedia.twitter &&
                    <a target='_blank' href={socialMedia.twitter}>
                      <img src={images.twitterFooter} alt="Twitter Loggo" />
                    </a>
                  }
                  { socialMedia.instagram &&
                    <a target="_blank" href={socialMedia.instagram}>
                      <img src={images.instagramFooter} alt="Instagram Logo" />
                    </a>
                  }
                   { socialMedia.youtube &&
                    <a target="_blank" href={socialMedia.youtube}>
                      <img src={images.youtubeFooter} alt="Youtube Logo" />
                    </a>
                  }
                </div>
              )
            }
        </div>
    </div>
  )
}

export default Copyright